import axios from 'axios';
import Cookies from 'js-cookie';

const COOKIE_EXPIRES_DAYS = 7;

export const setSession = (accessToken: string | null) => {
    if (accessToken) {
        Cookies.set('accessToken', accessToken, { expires: COOKIE_EXPIRES_DAYS });
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
        Cookies.remove('accessToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

const AUTH_ME_KEY = 'auth_me';

export const clearAuthTokens = () => {
    Cookies.remove('accessToken');
    try {
        localStorage.removeItem(AUTH_ME_KEY);
    } catch {
        // ignore
    }
};
